import React from "react"
import { Order, OrderHistory, StoreGroupSearchHit } from "lib/types/generated/graphql-types"
import {
  AddedComment,
  Comments,
  CommentWrapper,
  NoComments,
} from "./OrderTotals.styled"
import { Container } from "../../../../views/Orders/OrderViews/OrderInfo/OrderDetails.styled"
import AddComment from "../../OrderHistoryLog/AddComment"
import dayjs from "dayjs"
import OrderTotals from "./Totals/OrderTotals"

type Props = {
  order: Order
  orderHistory: OrderHistory
  storeGroups: StoreGroupSearchHit[]
  refetch: () => void
}

const OrderOverView = ({ order, storeGroups, refetch, orderHistory }: Props) => {
  const comments = orderHistory.history
    .filter((entry) => entry.type === "ADD_COMMENT")
    .reverse()
    .slice(0, 3)

  const getInitials = (userName: string) => {
    if (userName.includes("@")) {
      const name = userName.split("@")
      if (name[0].includes(".")) {
        const fragments = name[0].split(".")
        return `${fragments[0].slice(0, 1)}${fragments[1].slice(0, 1)}`
      }
    }
    return userName.slice(0, 1)
  }

  return (
    <>
    <Container>
      <OrderTotals order={order} storeGroups={storeGroups} />
      <Comments>
        <CommentWrapper>
          {comments.length === 0 && <NoComments>-No comments added</NoComments>}
          {comments.map((comment) => (
            <AddedComment>
              <span>{getInitials(comment?.actor?.name ?? "")}</span>
              <div>
                <b>{comment.comment?.text}</b>
                <p>{comment.actor?.name}</p>
                <p>{dayjs(comment?.timestamp).format("YYYY-MM-DD HH:mm")}</p>
              </div>
            </AddedComment>
          ))}
        </CommentWrapper>
        <AddComment orderId={order.id} refetch={refetch} />
      </Comments>
    </Container>
      </>
  )
}

export default OrderOverView
